import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconWallet1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.5C2 5.11929 3.11929 4 4.5 4H19.5C20.8807 4 22 5.11929 22 6.5V17.5C22 18.8807 20.8807 20 19.5 20H4.5C3.11929 20 2 18.8807 2 17.5V6.5ZM4.5 5C3.67157 5 3 5.67157 3 6.5V7H21V6.5C21 5.67157 20.3284 5 19.5 5H4.5ZM21 8H3V10L8.5 10C8.77614 10 9 10.2239 9 10.5V11.5C9 12.3284 9.67157 13 10.5 13H13.5C14.3284 13 15 12.3284 15 11.5V10.5C15 10.2239 15.2239 10 15.5 10L21 10V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWallet1;
